import { useState, useEffect } from 'react';
import { LineChart, Line, BarChart, Bar, PieChart, Pie, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { 
  LayoutDashboard, RefreshCw, TrendingUp, Target,
  MessageSquare, Brain, WifiOff, Send, ArrowUpRight,
  Loader2
} from 'lucide-react';
import API from '../services/api';

function Dashboard() {
  const [stats, setStats] = useState(null);
  const [messageData, setMessageData] = useState([]);
  const [showWhatsAppAlert, setShowWhatsAppAlert] = useState(false);
  const [whatsAppAlertReason, setWhatsAppAlertReason] = useState('');
  const isSuperAdmin = localStorage.getItem('isSuperAdmin') === 'true';
  // NAYA:
useEffect(() => {
  loadDashboardData();
  checkWhatsAppStatus();

  // Checkout se subscription_updated aaye to reload karo
  const handleStorage = (e) => {
    if (e.key === 'subscription_updated') {
      window.location.reload();
    }
  };
  window.addEventListener('storage', handleStorage);
  return () => window.removeEventListener('storage', handleStorage);
}, []);

const checkWhatsAppStatus = async () => {
  if (isSuperAdmin) return; // Super admin ko ye alert nahi dikhana
  try {
    const response = await API.get('/organization/whatsapp-credentials');
    if (
      response.data.configured &&
      response.data.data &&
      !response.data.data.is_active
    ) {
      setWhatsAppAlertReason(response.data.data.deactivation_reason || '');
      setShowWhatsAppAlert(true);
    }
  } catch (error) {
    console.error('WhatsApp status check error:', error);
  }
};

  const loadDashboardData = async () => {
    try {
      const statsRes = await API.get('/analytics/dashboard');
      setStats(statsRes.data.data);

      const messageRes = await API.get('/analytics/messages');
      const formattedData = messageRes.data.data.byDate.map(item => ({
        date: new Date(item.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
        messages: parseInt(item.count)
      })).reverse().slice(0, 7);
      setMessageData(formattedData);
    } catch (error) {
      console.error('Error loading dashboard:', error);
    }
  };

  if (!stats) {
    return (
      <div className="loading-container">
        <div className="loading-content">
          <div className="loading-spinner">
  <Loader2 size={48} style={{animation:'spin 1s linear infinite', color:'#1e3a5f'}} />
</div>
<p className="loading-text">Loading dashboard...</p>
        </div>
      </div>
    );
  }

  const flowPieData = [
    { name: 'Published', value: stats.totals.publishedFlows, color: '#3b82f6' },
    { name: 'Draft',     value: stats.totals.flows - stats.totals.publishedFlows, color: '#cbd5e1' }
  ];

  const subscriptionPlan    = localStorage.getItem('subscriptionPlan');
  const subscriptionEndDate = localStorage.getItem('subscriptionEndDate');

  return (
  <div className="dash-page">

    {/* WhatsApp Deactivated Alert Modal */}
    {showWhatsAppAlert && (
      <div style={{
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex', justifyContent: 'center', alignItems: 'center',
        zIndex: 9999,
      }}>
        <div style={{
          backgroundColor: '#fff',
          borderRadius: '12px',
          maxWidth: '460px',
          width: '90%',
          overflow: 'hidden',
          boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
        }}>
          {/* Header */}
          <div style={{ backgroundColor: '#f59e0b', padding: '20px', display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{ width: '40px', height: '40px', borderRadius: '50%', backgroundColor: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
             <WifiOff size={20} color="white" />
            </div>
            <div>
              <h3 style={{ margin: 0, color: '#fff', fontSize: '18px', fontWeight: '700' }}>WhatsApp Integration Deactivated</h3>
              <p style={{ margin: '2px 0 0 0', color: 'rgba(255,255,255,0.9)', fontSize: '13px' }}>Service Unavailable</p>
            </div>
          </div>
          {/* Body */}
          <div style={{ padding: '24px' }}>
            <div style={{ background: '#fffbeb', border: '1px solid #fcd34d', borderRadius: '8px', padding: '14px', marginBottom: '16px' }}>
              <p style={{ margin: 0, fontSize: '14px', color: '#92400e', lineHeight: '1.6' }}>
                Your WhatsApp integration has been deactivated due to an insufficient or expired subscription plan.
                {whatsAppAlertReason ? ` (${whatsAppAlertReason})` : ''}
                {' '}Your chatbot will not respond to incoming messages until you renew your subscription.
              </p>
            </div>
            <div style={{ background: '#f9fafb', borderRadius: '8px', padding: '14px', marginBottom: '20px' }}>
              <p style={{ margin: '0 0 8px 0', fontSize: '13px', fontWeight: '600', color: '#374151' }}>What this means:</p>
              <ul style={{ margin: 0, paddingLeft: '18px', fontSize: '13px', color: '#6b7280', lineHeight: '1.8' }}>
                <li>Incoming WhatsApp messages will not be processed</li>
                <li>Your flow automations are paused</li>
                <li>Your credentials are safely saved — no reconfiguration needed</li>
                <li>Subscribe to any plan to instantly restore service</li>
              </ul>
            </div>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button
                onClick={() => window.location.href = '/pricing'}
style={{ flex: 1, padding: '12px', background: '#f59e0b', color: '#fff', border: 'none', borderRadius: '8px', fontWeight: '700', cursor: 'pointer', fontSize: '15px', display:'flex', alignItems:'center', justifyContent:'center', gap:'8px' }}              >
                <RefreshCw size={15} /> Subscribe Now

              </button>
              <button
                onClick={() => setShowWhatsAppAlert(false)}
                style={{ padding: '12px 20px', background: '#f3f4f6', color: '#374151', border: 'none', borderRadius: '8px', fontWeight: '600', cursor: 'pointer', fontSize: '15px' }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    )}

    <div className="dash-header">
        <div>
         <h1 className="dash-title" style={{display:'flex', alignItems:'center', gap:'10px'}}>
  <LayoutDashboard size={26} color="#1e3a5f" /> Dashboard
</h1>
          <p className="dash-subtitle">Welcome back! Here's what's happening with your chatbot platform.</p>
        </div>
        {subscriptionPlan && (
         <div className="dash-plan-badge" style={{display:'flex', alignItems:'center', gap:'8px'}}>
  <Brain size={15} /> {subscriptionPlan}
            {subscriptionEndDate && (
              <div className="dash-plan-expires">
                Expires: {new Date(subscriptionEndDate).toLocaleDateString()}
              </div>
            )}
          </div>
        )}
      </div>

      {/* Stat cards */}
      <div className="dash-stats-grid">
        <div className="dash-stat-card dash-stat-indigo">
          <div className="dash-stat-label">Total Flows</div>
          <div className="dash-stat-value">{stats.totals.flows}</div>
          <div className="dash-stat-sub">{stats.totals.publishedFlows} published</div>
        </div>
        <div className="dash-stat-card dash-stat-violet">
          <div className="dash-stat-label">Total Contacts</div>
          <div className="dash-stat-value">{stats.totals.contacts}</div>
          <div className="dash-stat-sub">{stats.today.contacts} added today</div>
        </div>
        <div className="dash-stat-card dash-stat-blue">
          <div className="dash-stat-label">Total Messages</div>
          <div className="dash-stat-value">{stats.totals.messages}</div>
          <div className="dash-stat-sub">All time</div>
        </div>
        <div className="dash-stat-card dash-stat-sky">
          <div className="dash-stat-label">Today's Messages</div>
          <div className="dash-stat-value">{stats.today.messages}</div>
          <div className="dash-stat-sub">Last 24 hours</div>
        </div>
      </div>

      {/* Charts */}
      <div className="dash-charts-grid">
        <div className="dash-card">
         <h3 className="dash-card-title" style={{display:'flex', alignItems:'center', gap:'8px'}}>
  <TrendingUp size={18} color="#3b82f6" /> Message Activity (Last 7 Days)
</h3>
          <div className="dash-chart-wrap">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={messageData}>
                <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                <XAxis dataKey="date" stroke="#94a3b8" fontSize={12} />
                <YAxis stroke="#94a3b8" fontSize={12} />
                <Tooltip contentStyle={{ background: 'white', border: '1px solid #e2e8f0', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }} />
                <Line type="monotone" dataKey="messages" stroke="#3b82f6" strokeWidth={2.5} dot={{ fill: '#3b82f6', r: 4 }} activeDot={{ r: 6 }} />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>

        <div className="dash-card">
          <h3 className="dash-card-title" style={{display:'flex', alignItems:'center', gap:'8px'}}>
  <Target size={18} color="#8b5cf6" /> Flow Status Distribution
</h3>
          <div className="dash-chart-wrap">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={flowPieData}
                  cx="50%" cy="50%"
                  labelLine={false}
                  label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                  outerRadius={80}
                  dataKey="value"
                >
                  {flowPieData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                  ))}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          </div>
          <div className="chart-legend">
            <div className="chart-legend-item">
              <div className="chart-legend-dot" style={{ background: '#3b82f6' }}></div>
              <span className="chart-legend-label">Published</span>
            </div>
            <div className="chart-legend-item">
              <div className="chart-legend-dot" style={{ background: '#cbd5e1' }}></div>
              <span className="chart-legend-label">Draft</span>
            </div>
          </div>
        </div>
      </div>

      {/* Recent Messages */}
      <div className="dash-card">
        <h3 className="dash-card-title" style={{display:'flex', alignItems:'center', gap:'8px'}}>
  <MessageSquare size={18} color="#1e3a5f" /> Recent Messages
</h3>
        {stats.recentMessages && stats.recentMessages.length > 0 ? (
          <div className="flex flex-col gap-md">
            {stats.recentMessages.slice(0, 5).map(msg => (
              <div
                key={msg.id}
                className={`recent-message-item ${msg.direction === 'outgoing' ? 'recent-message-outgoing' : 'recent-message-incoming'}`}
              >
                <div className="recent-message-header">
                  <span className="recent-message-name">{msg.contact_name}</span>
                  <span className="recent-message-time">{new Date(msg.created_at).toLocaleString()}</span>
                </div>
                <div className="recent-message-content">{msg.content}</div>
                <div className="recent-message-direction">
                  <span style={{display:'flex', alignItems:'center', gap:'5px'}}>
  {msg.direction === 'outgoing' 
    ? <><Send size={12} /> Sent</> 
    : <><ArrowUpRight size={12} style={{transform:'rotate(180deg)'}} /> Received</>}
</span>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="empty-state-text">No recent messages</p>
        )}
      </div>
    </div>
  );
}

export default Dashboard;